<template>
  <div class="create-lead-generation-form">
        <v-dialog v-model="dialog" persistent content-class="create-lead-form" transition="dialog-bottom-transition">
      <div class="lead-generation-form-container">
        <div class="heading flex">
          <div class="back flex mr-2 pointer" @click="$emit('close')">
            <v-icon color="#1D8D56">mdi-arrow-left</v-icon>
          </div>
          <h2 class="--green">Create Inquiry Form</h2>
        </div>

        <div class="labels secondary-font flex">
          <div class="left-portion">
            <small class="mr-5">Mandatory</small>
            <small>Your question / statement</small>
          </div>
          <div class="right-portion">
            <small>Answer type</small>
            <small class="ml-5">Remove</small>
          </div>
        </div>

        <div class="input-boxes">
          <div v-for="(form, index) in forms" :key="form.order" >
            <v-text-field
              class="mt-2"
              outlined
              hide-details
              v-model="form.label"
                            placeholder="Write your question / statement here.."> 
                                <v-checkbox v-model="form.is_compulsory" color="#1D8D56" hide-details slot="prepend-inner" class="check-box"/>
              <div slot="append" class="flex appender">
                <v-select
                  class="form-selection-box"
                  :items="formInputs"
                  item-text="display_text"
                  single-line
                  return-object
                  v-model="selectedItems[index]"
                                        style="width : 180px;" 
                  dense
                  hide-details
                  background-color="#EFF6F3"
                  append-icon="mdi-chevron-down"
                  outlined
                                        placeholder="Select Answer Type">
                  <template v-slot:selection="{ item }">
                                                <p  class="my-0 --green" 
                                                    style="white-space: nowrap; overflow : hidden;"> {{ item.display_text }} 
                    </p>
                  </template>
                </v-select>
                <v-icon
                  color="#D93D3D"
                  size="20"
                  class="delete-form pointer"
                                        @click="removeForm(form.order)">
                  mdi-close
                </v-icon>
              </div>
            </v-text-field>
                        <div class="options mt-2" v-if="forms[index].isMultipleChoiceSelected">
              <v-text-field
                class="answer-input"
                v-for="(input, i) in forms[index].form_input_property_options"
                :key="i"
                outlined
                placeholder="Add your answers here"
                hide-details=""
                append-icon="mdi-close"
                @click:append="deleteOptions(index, i)"
                                v-model="input.display_text1">

                <div class="alphabets --green --weight" slot="prepend-inner">
                  {{ input.index }}
                </div>
              </v-text-field>
                            <button class="--green add-answers --weight" @click="addAnswerInput(index)">Add another choice</button>
            </div>
          </div>
                    <button class="flex --green --weight add-form-button my-3" v-ripple @click="addForm">+ Add another field</button>
        </div>

        <div class="buttons flex">
                    <button class="--green --weight discard" v-ripple @click="$emit('close')">Discard</button>
                    <button :disabled="disableNext" 
            class="green-background white--text --weight next"
            v-ripple
                            @click="verifyAndOpenOverviewForm">Next</button>
        </div>
      </div>
    </v-dialog>
    <overview-lead-form
      :dialog="finishLeadGenFormModal"
      @reset="$emit('close')"
            @close="finishLeadGenFormModal = false"/>
  </div>
</template>

<script>
import { eventBus } from '../../../../main';
import overviewLeadGenerationForm from "./overview-lead-generation-form.vue";
export default {
    name : 'createLeadGenerationForm',

  data() {
    return {
            forms : [
        {
                    order : 1,
                    is_compulsory : false,
                    label : '',
                    form_input_property_options : [
            {
                            display_text1 : '',
                            order : 1,
                            index : 'A'
            },
            {
                            display_text1 : '',
                            order : 2,
                            index : 'B'
            },
          ],
                    isMultipleChoiceSelected : false
                }
      ],
            selectedItems : [],
            finishLeadGenFormModal : false,
            formIdentifier : {},
        }
  },

    computed : {
    formInputs() {
            return this.$store.getters['activeLeadsStore/GET_LEAD_FORM_CONFIGS'];
    },

    modifiedForms() {
      const forms = this.selectedItems.map((item, index) => {
                return {...this.forms[index], ...item}
            })
      return forms;
    },

    disableNext() {
      console.log("SELCTED ITEM-->", this.selectedItems, this.forms);
      let formwithoutlabel = 0;
      let display_text_absent = false;
      this.forms.map((form) => {
        if(!form.label){
          formwithoutlabel = form.order;
        }
                if(form.isMultipleChoiceSelected){
                    form.form_input_property_options.map(item => {
                        if(!display_text_absent && item.display_text1 === ""){
              display_text_absent = true;
            }
                    })
        }
            })
            if(formwithoutlabel){
        return true;
            }else if(formwithoutlabel===0 && this.forms.length !== this.selectedItems.length){
        return true;
            } else if(display_text_absent){
        return true;
      }
      return false;
    },
  },

  props: {
    dialog: {
      type: Boolean,
    },
  },

  watch: {
    modifiedForms: function (newValue) {
      newValue.forEach((value, index) => {
        if (
          value.input_type === "radio_box_group" ||
          value.input_type === "checkbox_group"
        ) {
          if (index != undefined)
            this.forms[value.order - 1].isMultipleChoiceSelected = true;
        } else {
          if (index != undefined)
            this.forms[value.order - 1].isMultipleChoiceSelected = false;
        }
      });
    },

    dialog: function (value) {
      if (!value) {
        this.selectedItems = [];
        this.forms = [
          {
            order: 1,
            is_compulsory: false,
            label: "",
            form_input_property_options: [
              {
                display_text1: "",
                order: 1,
                index: "A",
              },
              {
                display_text1: "",
                order: 2,
                index: "B",
              },
            ],
            isMultipleChoiceSelected: false,
          },
        ];
      }
    },
  },

  mounted() {
    eventBus.$on("setFormIdentifier", (data) => {
      this.formIdentifier = data;
    });
  },

  methods: {
    getFormConfigs() {
      this.$store.dispatch(
        "activeLeadsStore/getFormConfigs",
        this.formIdentifier
      );
    },

    addForm() {
      this.forms.push({
        order: this.forms.length + 1,
        is_compulsory: false,
        label: "",
        form_input_property_options: [
          {
            display_text1: "",
            order: 1,
            index: "A",
          },
          {
            display_text1: "",
            order: 2,
            index: "B",
          },
        ],
        isMultipleChoiceSelected: false,
      });
    },

    removeForm(order) {
      if (order === 1) {
        this.forms[0].label = "";
        this.forms[0].is_compulsory = false;
      }
      // else {
      // this.forms = this.forms.filter(form => {
      //     return form.order != order
      // })
      else {
        for (let i = 0; i < this.forms.length; i++) {
          if (this.forms[i].order == order) {
            this.selectedItems[order - 1] = "";
            this.selectedItems.splice(order - 1, 1);
          }
        }
        if (order == this.forms.length) {
          this.forms = this.forms.filter((form) => {
            return form.order != order;
          });
        }
        if (order < this.forms.length) {
          for (let i = 0; i < this.forms.length; i++) {
            if (this.forms[i].order == order) {
              this.forms = this.forms.filter((form) => {
                return form.order != order;
              });
            }
            if (this.forms[i].order > order) {
              this.forms[i].order--;
              console.log("RemoveForm", this.forms);
            }
          }
          
        }
      }

      console.log("removed", this.forms);
    },

    addAnswerInput(index) {
      let nextCharacter = String.fromCharCode(
        this.forms[index].form_input_property_options[
          this.forms[index].form_input_property_options.length - 1
        ].index.charCodeAt(0) + 1
      );
      this.forms[index].form_input_property_options.push({
        index: nextCharacter,
        display_text1: "",
        order:
          this.forms[index].form_input_property_options[
            this.forms[index].form_input_property_options.length - 1
          ].order + 1,
      });
    },

    deleteOptions(formIndex, optionIndex) {
      if (optionIndex === 0 || optionIndex === 1)
        this.forms[formIndex].form_input_property_options[
          optionIndex
        ].display_text1 = "";
      else {
        this.forms[formIndex].form_input_property_options = this.forms[
          formIndex
        ].form_input_property_options.filter((option) => {
          return (
            this.forms[formIndex].form_input_property_options[optionIndex] !=
            option
          );
        });
      }
    },

    verifyAndOpenOverviewForm() {
            const modifiedForms = this.modifiedForms.map(form => {
                form.form_input_property_options = form.form_input_property_options.filter(option => {
                    return option.display_text1 != '';
          });
        return form;
      });
      console.log(modifiedForms);
            this.$store.dispatch('activeLeadsStore/setLeadFormJSON', {form_inputs : modifiedForms});
      this.finishLeadGenFormModal = true;
        }
  },

    components : {
        "overview-lead-form" : overviewLeadGenerationForm
    }
}
</script>

<style lang="scss" scoped>

.lead-generation-form-container {
  padding: 20px;
}

.heading {
  justify-content: flex-start;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
}

.back {
    background: #EFF6F3;
  border-radius: 7px;
  width: 45px;
  height: 45px;
}

.labels {
  justify-content: space-between;
  margin-top: 20px;
  font-size: 0.9rem;
}

.check-box {
  margin-top: -5px;
}

.appender {
  margin-top: -8px;
}

.delete-form {
    background-color: #FEF7F7;
  height: 38px;
  border-radius: 5px;
  margin-left: 5px;
}

.add-form-button {
    background: #EFF6F3;
  border-radius: 7px;
  width: 100%;
  height: 45px;
}

.options {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
}

.alphabets {
    background: #EFF6F3;
  border-radius: 5px;
  padding: 13px 15px;
  transform: translateY(-10px);
}

.answer-input {
  margin-bottom: 10px;
}

.add-answers {
    background-color: #EFF6F3;
  width: 100%;
  height: 50px;
}

.buttons {
  justify-content: space-between;
  position: sticky;
  bottom: 10px;
  z-index: 1;
}

.discard {
    background: #EFF6F3;
  width: 29%;
}

.buttons button:not(.discard) {
  width: 69%;
  box-shadow: 1px 3px 3px rgba(46, 73, 50, 0.25);
}

.buttons button {
  border-radius: 5px;
  height: 50px;
}

.next:disabled {
  opacity: 0.4 !important;
}

</style>

<style lang="scss">

.create-lead-form.v-dialog {
  width: 60%;
  min-height: 630px;
  background-color: white;
}

.form-selection-box fieldset {
  color: white !important;
}

.form-selection-box .mdi::before {
  color: var(--primary-color) !important;
}

.form-selection-box input::placeholder {
  color: var(--primary-color) !important;
  opacity: 1;
  font-size: 0.9rem;
}

@media all and (min-width: 1500px) {
  .create-lead-form.v-dialog {
    width: 50%;
  }
}
</style>